var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5 53h2v8h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 50c0-1.654-1.346-3-3-3h-32c-1.654 0-3 1.346-3 3v1h38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 61h2v-6h2v6h2v-8h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 61h2v-6h2v6h2v-8h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 26v-2-19c0-1.103-.897-2-2-2s-2 .897-2 2v34h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 41c-.551 0-1 .449-1 1v3h14v-3c0-.551-.449-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 61h2v-6h2v6h2v-8h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 21c0-1.654-1.346-3-3-3h-1v-1c0-1.654-1.346-3-3-3-1.151 0-2.183.653-2.69 1.704l-.398.824-.856-.324c-.985-.373-1.954-.217-2.734.31l-1.076.728-.429-1.226c-.422-1.206-1.554-2.016-2.817-2.016-1.408 0-2.642.999-2.933 2.376l-.222 1.048-1.031-.293c-.878-.251-1.454-.14-2.117.182l-.819.399-.474-.778c-.736-1.211-2.008-1.934-3.404-1.934-2.206 0-4 1.794-4 4v2.184c.314-.112.648-.184 1-.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 61h2v-6h2v6h2v-8h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.158 39.925c.519.54.842 1.269.842 2.075v3h7c2.757 0 5 2.243 5 5v3h-2v4h11.469c1.51 0 2.79-1.13 2.977-2.628l2.453-25.372h-28.798zm18.842 13.075h3l.391-3.124 1.984.248-.391 3.124c-.124.999-.977 1.752-1.984 1.752h-3zm-4 0h2v2h-2zm-6-22h2v2h-2zm-4 0h2v2h-2zm-4 0h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 23h-33c-.551 0-1 .449-1 1v2c0 .551.449 1 1 1h33c.551 0 1-.449 1-1v-2c0-.551-.449-1-1-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 9,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 33,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.f9af5784f5aedc1868d99f58de04be10.svg";
export { ForwardRef as ReactComponent };